
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return new URL($parcel$distDir + url, import.meta.url).toString();
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire982d"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire982d"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("dkTiG", function(module, exports) {

var $1ymnP = parcelRequire("1ymnP");

var $9Z03A = parcelRequire("9Z03A");

var $8bUbP = parcelRequire("8bUbP");

var $p0Det = parcelRequire("p0Det");
requestIdleCallback(()=>{
    (0, $1ymnP.setupCalJs)();
    (0, $9Z03A.snowAnimationStart)((0, $8bUbP.snowfallJsPluginParams));
    /* 
    The language preference check and text translation rendering happens in a different process and will have been triggered before the snow animation switches are appended to the DOM. Thus, re-render the span text element text once the snowAnimationSwitch are present in the DOM.
  */ const switchesTextElems = document.querySelectorAll(".snow-animation-switch span");
    if (switchesTextElems.length > 0) (0, $p0Det.reRenderTextElementText)(switchesTextElems);
});

});
parcelRegister("1ymnP", function(module, exports) {

$parcel$export(module.exports, "setupCalJs", function () { return $121a544d649ce143$export$8d945a966a7346e9; });
/*
###################  
Cal.com plugin code 
###################  
*/ function $121a544d649ce143$export$9340b22841e69e75(C, A, L) {
    let p = function(a, ar) {
        a.q.push(ar);
    };
    let d = C.document;
    C.Cal = C.Cal || function() {
        let cal = C.Cal;
        let ar = arguments;
        if (!cal.loaded) {
            cal.ns = {};
            cal.q = cal.q || [];
            d.head.appendChild(d.createElement("script")).src = A;
            cal.loaded = true;
        }
        if (ar[0] === L) {
            const api = function() {
                p(api, arguments);
            };
            const namespace = ar[1];
            api.q = api.q || [];
            typeof namespace === "string" ? (cal.ns[namespace] = api) && p(api, ar) : p(cal, ar);
            return;
        }
        p(cal, ar);
    };
}
function $121a544d649ce143$export$8d945a966a7346e9() {
    // Important: Make sure to add `data-cal-link="liondigits/20min"` attribute to the element you want to open Cal on click
    try {
        $121a544d649ce143$export$9340b22841e69e75(window, "https://app.cal.com/embed/embed.js", "init");
        Cal("init", {
            origin: "https://app.cal.com"
        });
        Cal("ui", {
            theme: "dark",
            styles: {
                branding: {
                    brandColor: "#003F8C"
                }
            },
            hideEventTypeDetails: false
        });
    } catch (e) {
        console.log("Calendar unable to loaded");
    }
}

});

parcelRegister("9Z03A", function(module, exports) {

$parcel$export(module.exports, "snowfallState", function () { return $7449dadda7c5bef9$export$5596bf805767acab; });
$parcel$export(module.exports, "params", function () { return $7449dadda7c5bef9$export$281ad3752a540efe; });
$parcel$export(module.exports, "snowAnimationStart", function () { return $7449dadda7c5bef9$export$e539e1c934021278; });
$parcel$export(module.exports, "initSnowfall", function () { return $7449dadda7c5bef9$export$341e4017f7fc0f7a; });

var $cydX5 = parcelRequire("cydX5");

var $aqsmU = parcelRequire("aqsmU");

var $hMCj5 = parcelRequire("hMCj5");

var $1Q7uz = parcelRequire("1Q7uz");

var $g8WoB = parcelRequire("g8WoB");

var $2rQlw = parcelRequire("2rQlw");
const $7449dadda7c5bef9$export$5596bf805767acab = {
    snowfallInstance: undefined,
    isAnimationRunning: false
};
let $7449dadda7c5bef9$export$281ad3752a540efe = {};
function $7449dadda7c5bef9$export$e539e1c934021278(configParams = {}) {
    if (configParams.logLevel === "info") $7449dadda7c5bef9$export$281ad3752a540efe.logLevel = "info";
    (0, $2rQlw.logInfo)("Validating snowfall-js-plugin parameters...");
    $7449dadda7c5bef9$export$281ad3752a540efe = (0, $1Q7uz.setParams)(configParams);
    const canRun = (0, $aqsmU.canRunAnimation)($7449dadda7c5bef9$export$281ad3752a540efe);
    if (canRun) {
        const autoStart = (0, $g8WoB.getAutoStart)($7449dadda7c5bef9$export$281ad3752a540efe);
        (0, $hMCj5.switchesAppendToDOM)($7449dadda7c5bef9$export$281ad3752a540efe);
        (0, $hMCj5.switchesSetupEventHandlers)($7449dadda7c5bef9$export$281ad3752a540efe);
        if (autoStart) {
            $7449dadda7c5bef9$export$5596bf805767acab.snowfallInstance = $7449dadda7c5bef9$export$341e4017f7fc0f7a($7449dadda7c5bef9$export$281ad3752a540efe.snowfall);
            $7449dadda7c5bef9$export$5596bf805767acab.isAnimationRunning = true;
            (0, $hMCj5.switchesToggleOn)();
            (0, $2rQlw.logInfo)("Done loading and starting animation.");
        }
    } else return;
}
function $7449dadda7c5bef9$export$341e4017f7fc0f7a(params) {
    try {
        const snowfall = new (0, $cydX5.Snowfall)(params);
        return snowfall;
    } catch (err) {
        (0, $2rQlw.logError)("Error initializing Snowfall instance");
        throw err;
    }
}

});
parcelRegister("cydX5", function(module, exports) {

$parcel$export(module.exports, "Snowfall", function () { return $92337b976f6f4aba$export$863fc42fa99cded6; });
/*!
 * Snowfall.js - A JavaScript library for creating and animating snowflakes on a web page
 * https://github.com/Andrey-1988-dev/snowfall.js
 *
 * Author: Andrey Yurkevich (https://github.com/Andrey-1988-dev)
 * Contact: yurkevich.a.n.1988@gmail.com
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program.  If not, see <https://www.gnu.org/licenses/>.
 *
 * Version: 1.1.0
 * Date: 2021-11-27T00:00Z
 *
 * Date Modified: 2024-01-31
 * The current code below is a fork of the original with minor additions,
 * optimization and extensions. The same license applies.
 *
 * Contributor: Joris Raymaekers (https://liondigits.com/)
 * Contact: joris@liondigits.com
 * Github: https://github.com/jorishr/snowfall-js-plugin
 */ 
var $9Z03A = parcelRequire("9Z03A");
class $92337b976f6f4aba$export$3966b366d9a665fb {
    /**
   * Creates a snowflake instance with random coordinates, font size, speed, color, and text.
   *
   * @param {HTMLCanvasElement} canvas - The canvas element.
   * @param {number} h - The font size / height of snowflake.
   * @param {number} s - The speed.
   * @param {string} c - The color.
   * @param {string} t - The text.
   */ constructor(canvas, h, s, c, t){
        this.x = Math.random() * canvas.width;
        this.y = Math.random() * canvas.height;
        this.h = h;
        this.s = s;
        this.c = c;
        this.t = t;
    }
    /**
   * Calculates and returns the new position of the snowflake relative to the edge of the canvas.
   *
   * @param {number} oldPosition - The old position of the snowflake.
   * @param {number} oldCanvasSize - The old size of the canvas.
   * @param {number} newCanvasSize - The new size of the canvas.
   * @returns {number} - The new position of the snowflake.
   */ calculateNewPosition = (oldPosition, oldCanvasSize, newCanvasSize)=>{
        let percentage = oldPosition / (oldCanvasSize / 100);
        return newCanvasSize / 100 * percentage;
    };
    /**
   * Updates the position of the snowflake after canvas resize.
   *
   * @param {number} oldCanvasWidth - The old canvas width.
   * @param {number} oldCanvasHeight - The old canvas height.
   * @param {number} newCanvasWidth - The new canvas width.
   * @param {number} newCanvasHeight - The new canvas height.
   */ updateAfterCanvasResize = (oldCanvasWidth, oldCanvasHeight, newCanvasWidth, newCanvasHeight)=>{
        if (oldCanvasWidth !== newCanvasWidth) this.x = this.calculateNewPosition(this.x, oldCanvasWidth, newCanvasWidth);
        if (oldCanvasHeight !== newCanvasHeight) this.y = this.calculateNewPosition(this.y, oldCanvasHeight, newCanvasHeight);
    };
    /**
   * Draws the snowflake on the canvas if it is within the visible area.
   *
   * @param {CanvasRenderingContext2D} ctx - The canvas rendering context.
   */ draw = (ctx)=>{
        // Check if the snowflake is within the visible area
        if (this.x + this.h >= window.scrollX && this.x - this.h <= window.scrollX + window.innerWidth && this.y + this.h >= window.scrollY && this.y - this.h <= window.scrollY + window.innerHeight) {
            ctx.fillStyle = this.c; // set the color
            ctx.font = this.h + "px Arial, sans-serif"; // set the font and text size
            ctx.fillText(this.t, this.x, this.y); // draw the text with the snowflake symbol
        }
    };
    /**
   * Batch draws snowflakes for better performance.
   *
   * @param {CanvasRenderingContext2D} ctx - The canvas rendering context.
   * @param {Snowflake[]} snowflakes - Array of snowflake instances.
   * @param {number} scrollX - The horizontal scroll position.
   * @param {number} scrollY - The vertical scroll position.
   * @param {number} windowWidth - The window width.
   * @param {number} windowHeight - The window height.
   */ static batchDraw(ctx, snowflakes, scrollX, scrollY, windowWidth, windowHeight) {
        // FillStyle is the same for all snowflakes
        ctx.fillStyle = snowflakes[0].c;
        ctx.beginPath();
        for (let snowflake of snowflakes)if (snowflake.isVisible(scrollX, scrollY, windowWidth, windowHeight)) {
            ctx.font = snowflake.h + "px Arial, sans-serif";
            ctx.fillText(snowflake.t, snowflake.x, snowflake.y);
        }
        ctx.closePath();
        ctx.fill();
    }
    /**
   * Checks if the snowflake is inside the visible window.
   *
   * @param {number} scrollX - The horizontal scroll position.
   * @param {number} scrollY - The vertical scroll position.
   * @param {number} windowWidth - The window width.
   * @param {number} windowHeight - The window height.
   * @returns {boolean} - True if visible, false otherwise.
   */ isVisible = (scrollX, scrollY, windowWidth, windowHeight)=>{
        return this.x + this.h >= scrollX && this.x - this.h <= scrollX + windowWidth && this.y + this.h >= scrollY && this.y - this.h <= scrollY + windowHeight;
    };
    /**
   * Updates the position of the snowflake.
   *
   * @param {HTMLCanvasElement} canvas - The canvas element.
   */ update = (canvas)=>{
        // increase the y coordinate by the speed
        this.y += this.s;
        if (this.s > 0) // if the snowflake goes beyond the bottom edge of the canvas, move it to the top
        {
            if (this.y > canvas.height) {
                this.y = -this.h;
                this.x = Math.random() * canvas.width;
            }
        } else if (this.y < 0) {
            this.y = canvas.height + this.h;
            this.x = Math.random() * canvas.width;
        }
    };
}
class $92337b976f6f4aba$export$863fc42fa99cded6 {
    requestAnimationFrame;
    /**
   * Create a Snowfall instance with customizable options.
   *
   * @param {Object} options - Configuration options for the snowfall animation.
   * @param {number} options.count - Number of snowflakes.
   * @param {number} options.minRadius - Minimum radius of snowflakes.
   * @param {number} options.maxRadius - Maximum radius of snowflakes.
   * @param {number} options.minSpeed - Minimum falling speed of snowflakes.
   * @param {number} options.maxSpeed - Maximum falling speed of snowflakes.
   * @param {string} options.text - Text or symbol representing the snowflake.
   * @param {string} options.color - Color of the snowflakes.
   * @param {string} options.zIndex - Z-index of the snowfall canvas.
   */ constructor(options = {}){
        let { count: count = 100, minRadius: minRadius = 10, maxRadius: maxRadius = 30, minSpeed: minSpeed = 3, maxSpeed: maxSpeed = 10, text: text = "\u2744", color: color = "#99ccff", zIndex: zIndex = "1000" } = options;
        count = Number(count);
        minRadius = Number(minRadius);
        if (minRadius <= 0) minRadius = 10;
        maxRadius = Number(maxRadius);
        if (maxRadius <= 0) maxRadius = 30;
        minSpeed = Number(minSpeed);
        maxSpeed = Number(maxSpeed);
        const snowfieldCanvas = document.createElement("canvas");
        snowfieldCanvas.id = "snowfall";
        snowfieldCanvas.style.zIndex = zIndex;
        snowfieldCanvas.style.position = "absolute";
        snowfieldCanvas.style.top = "0";
        snowfieldCanvas.style.left = "0";
        snowfieldCanvas.style.pointerEvents = "none";
        document.body.append(snowfieldCanvas);
        this.canvas = snowfieldCanvas;
        this.ctx = this.canvas.getContext("2d");
        this.resizeCanvas();
        window.addEventListener("resize", this.resizeHandler);
        this.resizeHandler = ()=>{
            requestAnimationFrame(this.resizeCanvas.bind(this));
        };
        this.snowflakes = [];
        this.count = count;
        this.minRadius = minRadius;
        this.maxRadius = maxRadius;
        this.minSpeed = minSpeed;
        this.maxSpeed = maxSpeed;
        this.color = color;
        this.text = text;
        this.createSnowflakes();
        this.animateSnowflakes();
    }
    /**
   * Resize the canvas and update snowflake positions after a window resize.
   */ resizeCanvas = ()=>{
        let oldCanvasWidth, oldCanvasHeight;
        if (this.snowflakes) {
            oldCanvasWidth = this.canvas.width;
            oldCanvasHeight = this.canvas.height;
        }
        this.canvas.style.display = "none";
        // Set the width and height of the canvas equal to the width and height of the browser window
        if (window.devicePixelRatio > 1) {
            let scrollWidth = document.documentElement.scrollWidth;
            let scrollHeight;
            if ((0, $9Z03A.params).snowfall.canvasHeightLimit !== 0) scrollHeight = Math.min(document.documentElement.scrollHeight, window.innerHeight * (0, $9Z03A.params).snowfall.canvasHeightLimit);
            else scrollHeight = document.documentElement.scrollHeight;
            this.canvas.width = scrollWidth * window.devicePixelRatio;
            this.canvas.height = scrollHeight * window.devicePixelRatio;
            this.canvas.style.width = scrollWidth + "px";
            this.canvas.style.height = scrollHeight + "px";
            this.ctx.scale(window.devicePixelRatio, window.devicePixelRatio);
        } else {
            this.canvas.width = document.documentElement.scrollWidth;
            this.canvas.height = document.documentElement.scrollHeight;
        }
        this.canvas.style.display = "";
        if (this.snowflakes) {
            let newCanvasWidth = this.canvas.width;
            let newCanvasHeight = this.canvas.height;
            for (let snowflake of this.snowflakes)snowflake.updateAfterCanvasResize(oldCanvasWidth, oldCanvasHeight, newCanvasWidth, newCanvasHeight);
        }
    };
    /**
   * Create snowflakes based on the specified count and parameters.
   * Generates a random radius (r) within the minimum and maximum radius.
   * Generates a relative value (rp) which is the position inside the specified
   * radius range: 0-100. This is is used to adjust the speed of the snowflake * according to its size.
   * Generates the speed (s) based on the size of the snowflake.
   */ createSnowflakes = ()=>{
        for(let i = 0; i < this.count; i++){
            let r = this.minRadius + Math.random() * (this.maxRadius - this.minRadius);
            let rp;
            if (this.minRadius !== this.maxRadius) rp = (r - this.minRadius) / ((this.maxRadius - this.minRadius) / 100);
            else rp = 100;
            let s = this.minSpeed + (this.maxSpeed - this.minSpeed) / 100 * rp;
            let snowflake = new $92337b976f6f4aba$export$3966b366d9a665fb(this.canvas, r, s, this.color, this.text);
            this.snowflakes.push(snowflake);
        }
    };
    /**
   * Animate the snowflakes by clearing the canvas and updating their positions.
   */ animateSnowflakes = ()=>{
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
        $92337b976f6f4aba$export$3966b366d9a665fb.batchDraw(this.ctx, this.snowflakes, window.scrollX, window.scrollY, window.innerWidth, window.innerHeight);
        // Update the positions of the snowflakes
        for (let snowflake of this.snowflakes)snowflake.update(this.canvas);
        // Request a new animation frame
        this.requestAnimationFrame = requestAnimationFrame(this.animateSnowflakes);
    };
    /**
   * Destroy the snowfall animation and remove the canvas element.
   */ destroy = ()=>{
        window.removeEventListener("resize", this.resizeHandler);
        cancelAnimationFrame(this.requestAnimationFrame);
        document.getElementById("snowfall").remove();
        for(let name in this)delete this[name];
        // Empty the array of snowflakes
        this.snowflakes = [];
    };
}

});

parcelRegister("aqsmU", function(module, exports) {

$parcel$export(module.exports, "canRunAnimation", function () { return $7972567e3d9a3c43$export$babdb309e5f76aee; });

var $hjWK1 = parcelRequire("hjWK1");

var $c3BL3 = parcelRequire("c3BL3");

var $2rQlw = parcelRequire("2rQlw");

var $6aTH5 = parcelRequire("6aTH5");
function $7972567e3d9a3c43$export$babdb309e5f76aee(configParams) {
    let hardwareCheck;
    let insideDateRange;
    let accessibilityCheck = true;
    if (configParams.checkHardware) hardwareCheck = (0, $c3BL3.checkHardware)();
    else hardwareCheck = true;
    if (configParams.checkDateRange) insideDateRange = (0, $hjWK1.checkDateRange)(configParams.dateRange);
    else insideDateRange = true;
    if (configParams.checkReducedMotionPreference) accessibilityCheck = (0, $6aTH5.checkReducedMotionConfig)(configParams);
    (0, $2rQlw.logInfo)(`Result of canRunAnimationCheck: hardwareCheck: ${hardwareCheck}; insideDateRange: ${insideDateRange}; accessibilityCheck: ${accessibilityCheck}`);
    return hardwareCheck && insideDateRange && accessibilityCheck;
}

});
parcelRegister("hjWK1", function(module, exports) {

$parcel$export(module.exports, "checkDateRange", function () { return $c9c1c6ceee07f469$export$6462223ab70e10af; });

var $2rQlw = parcelRequire("2rQlw");
function $c9c1c6ceee07f469$export$6462223ab70e10af(dateRange = {}) {
    let result = false;
    let validDateRange = true;
    if (Object.keys(dateRange).length !== 0) {
        validDateRange = $c9c1c6ceee07f469$export$c03bb0116ee09d4b(dateRange.startMonth, dateRange.startDay) && $c9c1c6ceee07f469$export$c03bb0116ee09d4b(dateRange.endMonth, dateRange.endDay);
        if (dateRange.startMonth === dateRange.endMonth && dateRange.startDay >= dateRange.endDay) validDateRange = false;
    }
    validDateRange ? result = $c9c1c6ceee07f469$var$checkCurrentDate(dateRange) : (0, $2rQlw.logError)("Invalid date range values provided in the config file. Check documentation for more information.");
    (0, $2rQlw.logInfo)(`Check Date Range Result: ${result}`);
    return result;
}
/**
 * Validates the currentDate and passes the currentDate and dateRange values to the final verification check.
 *
 * @param {Object} dateRange - Object containing startMonth, startDay, endMonth, and endDay.
 * @returns {boolean} - True if the current date is within the range, false otherwise.
 */ function $c9c1c6ceee07f469$var$checkCurrentDate(dateRange) {
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth() + 1;
    const currentDay = currentDate.getDate();
    // Define the start and end dates for the condition, fallback to default
    const startMonth = dateRange.startMonth || 12; // December
    const startDay = dateRange.startDay || 15;
    const endMonth = dateRange.endMonth || 2; // February
    const endDay = dateRange.endDay || 15;
    return $c9c1c6ceee07f469$var$isInDateRange(currentMonth, currentDay, startMonth, endMonth, startDay, endDay);
}
/**
 * Checks if the current date is within the specified date range.
 *
 * @param {number} currentMonth - Current month.
 * @param {number} currentDay - Current day.
 * @param {number} startMonth - Start month of the date range.
 * @param {number} endMonth - End month of the date range.
 * @param {number} startDay - Start day of the date range.
 * @param {number} endDay - End day of the date range.
 * @returns {boolean} - True if the current date is within the range, false otherwise.
 */ function $c9c1c6ceee07f469$var$isInDateRange(currentMonth, currentDay, startMonth, endMonth, startDay, endDay) {
    if (startMonth < endMonth) return currentMonth === startMonth && currentDay >= startDay || currentMonth > startMonth && currentMonth < endMonth || currentMonth === endMonth && currentDay <= endDay;
    else if (startMonth === endMonth) return currentDay >= startDay && currentDay <= endDay;
    else return currentMonth === startMonth && currentDay >= startDay || currentMonth > startMonth && currentMonth <= 12 || currentMonth >= 1 && currentMonth < endMonth || currentMonth === endMonth && currentDay <= endDay;
}
function $c9c1c6ceee07f469$export$c03bb0116ee09d4b(month, day) {
    if (typeof month !== "number" || typeof day !== "number") return false;
    if (month < 1 || month > 12) return false;
    // Check if the day is in the valid range based on the month
    if (day < 1 || day > $c9c1c6ceee07f469$var$getDaysInMonth(month)) return false;
    return true;
}
/**
 * Gets the number of days in a given month.
 *
 * @param {number} month - Month for which to get the number of days.
 * @returns {number} - Number of days in the specified month.
 */ function $c9c1c6ceee07f469$var$getDaysInMonth(month) {
    const daysInMonth = [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ];
    return daysInMonth[month - 1];
}

});
parcelRegister("2rQlw", function(module, exports) {

$parcel$export(module.exports, "logError", function () { return $1c86b537deb6a0ee$export$58da9968c3170cb1; });
$parcel$export(module.exports, "logWarn", function () { return $1c86b537deb6a0ee$export$cc36178e946876e8; });
$parcel$export(module.exports, "logInfo", function () { return $1c86b537deb6a0ee$export$89c0607256d35f0a; });

var $9Z03A = parcelRequire("9Z03A");
function $1c86b537deb6a0ee$export$58da9968c3170cb1(message) {
    console.error(`[ERROR] ${message}`);
}
function $1c86b537deb6a0ee$export$cc36178e946876e8(message) {
    if ((0, $9Z03A.params).logLevel === "info") console.warn(`[WARN] ${message}`);
}
function $1c86b537deb6a0ee$export$89c0607256d35f0a(message) {
    if ((0, $9Z03A.params).logLevel === "info") console.log(`[INFO] ${message}`);
}

});


parcelRegister("c3BL3", function(module, exports) {

$parcel$export(module.exports, "checkHardware", function () { return $8c730dcfdfb50844$export$fee43c3493ccc8e0; });

var $2rQlw = parcelRequire("2rQlw");
function $8c730dcfdfb50844$export$fee43c3493ccc8e0() {
    const cpuCores = navigator.hardwareConcurrency;
    const deviceMemory = navigator.deviceMemory;
    (0, $2rQlw.logInfo)(`Hardware Memory: ${deviceMemory} GB`);
    (0, $2rQlw.logInfo)(`Number of CPU cores: ${cpuCores}`);
    if (deviceMemory >= 4 || cpuCores >= 4) return true;
    else return false;
}

});

parcelRegister("6aTH5", function(module, exports) {

$parcel$export(module.exports, "checkReducedMotionConfig", function () { return $47eee0e6b0191085$export$1cf545b25ac5269e; });
$parcel$export(module.exports, "validateReduceMultiplier", function () { return $47eee0e6b0191085$export$c2cce2c495aa1aea; });

var $2rQlw = parcelRequire("2rQlw");
function $47eee0e6b0191085$export$1cf545b25ac5269e(configParams) {
    const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion)").matches;
    if (prefersReducedMotion && configParams.setReducedMotion === "disable") return false;
    else return true; // case: setReducedMotion = "reduce" or no-preference set in browser configuration
}
function $47eee0e6b0191085$export$c2cce2c495aa1aea(configParams) {
    const inRange = configParams.reduceMultiplier > 0.1 && configParams.reduceMultiplier < 0.9;
    if (inRange) return configParams.reduceMultiplier;
    else {
        (0, $2rQlw.logWarn)(`Input ${configParams.reduceMultiplier} is an invalid motion reduce multiplier value. Use a number value between 0.1 and 0.9! Fallback value 0.5 will be used.`);
        return 0.5;
    }
}

});


parcelRegister("hMCj5", function(module, exports) {

$parcel$export(module.exports, "switchesAppendToDOM", function () { return $cf24a24bca078afc$export$48d655b99b5ade63; });
$parcel$export(module.exports, "switchesToggleOn", function () { return $cf24a24bca078afc$export$e180b1645289b623; });
$parcel$export(module.exports, "switchesSetupEventHandlers", function () { return $cf24a24bca078afc$export$8b810da3348543c0; });

var $aIQ6J = parcelRequire("aIQ6J");

var $9Z03A = parcelRequire("9Z03A");

var $2rQlw = parcelRequire("2rQlw");
function $cf24a24bca078afc$export$48d655b99b5ade63(params) {
    const switchContainers = document.querySelectorAll(".snow-animation-switch");
    if (switchContainers.length > 0) {
        switchContainers.forEach((container, i)=>{
            const switchElements = $cf24a24bca078afc$var$buildSwitch(i, params);
            switchElements.forEach((elem)=>container.appendChild(elem));
            container.classList.add("snow-animation-switch--show");
        });
        if (params.switches.injectCSS) $cf24a24bca078afc$var$injectCSS(params);
        (0, $2rQlw.logInfo)(`${switchContainers.length} switch container elements found and ${switchContainers.length} switch toggles appended to the DOM.`);
    } else {
        (0, $2rQlw.logWarn)("No switch container elements found in the DOM. Make sure you have at least one <div class='snow-animation-switch'></div>.");
        return null;
    }
}
/**
 * Builds snowfall switch elements.
 *
 * @param {number} i - Index for creating unique IDs.
 * @param {Object} params - Snowfall parameters.
 * @returns {HTMLElement[]} - Array of switch elements.
 */ function $cf24a24bca078afc$var$buildSwitch(i, params) {
    const inputElem = document.createElement("input");
    const label = document.createElement("label");
    const textElem = document.createElement("span");
    inputElem.classList.add("snow-animation-switch__input");
    inputElem.type = "checkbox";
    inputElem.id = `snow-animation-switch__input${i}`;
    label.classList.add("snow-animation-switch__label");
    label.htmlFor = `snow-animation-switch__input${i}`;
    label.tabIndex = 0;
    textElem.classList.add("snow-animation-switch__text");
    textElem.textContent = params.switches.txt;
    if (params.switches.txtElemAttributes.length > 0) $cf24a24bca078afc$var$setElemAttributes(textElem, params.switches.txtElemAttributes);
    return [
        inputElem,
        label,
        textElem
    ];
}
/**
 * Sets attributes on an HTML element.
 *
 * @param {HTMLElement} elem - The HTML element to set attributes on.
 * @param {Object[]} attributes - Array of attribute objects.
 */ function $cf24a24bca078afc$var$setElemAttributes(elem, attributes) {
    attributes.forEach((attr)=>{
        if (attr.type === "data-attribute") elem.dataset[attr.name] = attr.value;
        else elem[attr.name] = attr.value;
    });
}

/**
 * Injects CSS stylesheet into the document.
 *
 * @param {Object} params - Snowfall parameters.
 */ function $cf24a24bca078afc$var$injectCSS(params) {
    const linkElement = document.createElement("link");
    const root = document.documentElement;
    const rootStyles = params.switches.styles;
    for(const key in rootStyles){
        root.style.setProperty(`--snow-animation-switch-${key}`, rootStyles[key]);
        if (key === "txtPosition" && rootStyles[key] === "1") root.style.setProperty(`--snow-animation-switch-txtMargin`, "0 0.75em 0 0");
    }
    linkElement.rel = "stylesheet";
    linkElement.type = "text/css";
    linkElement.href = new URL((parcelRequire("3CjFT")));
    document.head.appendChild(linkElement);
}
function $cf24a24bca078afc$export$e180b1645289b623() {
    const inputElems = document.querySelectorAll(".snow-animation-switch__input");
    inputElems.forEach((elem)=>{
        elem.checked = true;
        elem.ariaChecked = true;
        (0, $2rQlw.logInfo)("Switch toggled ON");
    });
}
function $cf24a24bca078afc$export$8b810da3348543c0(params) {
    const labelElems = document.querySelectorAll(".snow-animation-switch__label");
    labelElems.forEach((label)=>{
        label.addEventListener("click", (event)=>$cf24a24bca078afc$var$handleEvents(event, undefined, params));
        label.addEventListener("keydown", (event)=>{
            event.preventDefault();
            if (event.key === "Enter" || event.keyCode === 13) $cf24a24bca078afc$var$handleEvents(event, label, params);
        });
    });
}
/**
 * Handles click and enter key events for snowfall switches.
 *
 * @param {Event} event - The event object.
 * @param {HTMLElement} label - The label element associated with the switch.
 * @param {Object} params - Snowfall parameters.
 */ function $cf24a24bca078afc$var$handleEvents(event, label, params) {
    if ((0, $9Z03A.snowfallState).isAnimationRunning) {
        $cf24a24bca078afc$var$stopAnimation(event, params);
        /* the enter key event does not check the checkbox automatically */ if (label) {
            label.previousElementSibling.checked = false;
            label.previousElementSibling.ariaChecked = false;
        }
    } else {
        $cf24a24bca078afc$var$startAnimation(event, params);
        if (label) {
            label.previousElementSibling.checked = true;
            label.previousElementSibling.ariaChecked = true;
        }
    }
}
/**
 * Stops the snowfall animation and updates switch states.
 *
 * @param {Event} event - The event object.
 * @param {Object} params - Snowfall parameters.
 */ function $cf24a24bca078afc$var$stopAnimation(event, params) {
    (0, $9Z03A.snowfallState).snowfallInstance.destroy();
    (0, $9Z03A.snowfallState).isAnimationRunning = false;
    (0, $2rQlw.logInfo)("Animation stopped.");
    if (params.switches.storeUserSettings) (0, $aIQ6J.setUserSettings)({
        runSnowfallAnimation: false
    });
    $cf24a24bca078afc$var$syncStateOtherSwitches(event);
}
/**
 * Starts the snowfall animation and updates switch states.
 *
 * @param {Event} event - The event object.
 * @param {Object} params - Snowfall parameters.
 */ function $cf24a24bca078afc$var$startAnimation(event, params) {
    (0, $9Z03A.snowfallState).snowfallInstance = (0, $9Z03A.initSnowfall)(params.snowfall);
    (0, $9Z03A.snowfallState).isAnimationRunning = true;
    (0, $2rQlw.logInfo)("Animation started.");
    if (params.switches.storeUserSettings) (0, $aIQ6J.setUserSettings)({
        runSnowfallAnimation: true
    });
    $cf24a24bca078afc$var$syncStateOtherSwitches(event);
}
/**
 * Syncs the state of other switches based on the current switch state.
 *
 * @param {Event} event - The event object.
 */ function $cf24a24bca078afc$var$syncStateOtherSwitches(event) {
    document.querySelectorAll(".snow-animation-switch__input").forEach((elem)=>{
        if (elem.id !== event.target.previousElementSibling.id) {
            elem.checked = (0, $9Z03A.snowfallState).isAnimationRunning;
            elem.ariaChecked = (0, $9Z03A.snowfallState).isAnimationRunning;
            (0, $2rQlw.logInfo)("Switch state synced.");
        }
    });
}

});
parcelRegister("aIQ6J", function(module, exports) {

$parcel$export(module.exports, "checkUserSettings", function () { return $7ce66ef054949ea8$export$8a2e0f615212a6a7; });
$parcel$export(module.exports, "setUserSettings", function () { return $7ce66ef054949ea8$export$a09ac3e43ac36a79; });

var $2rQlw = parcelRequire("2rQlw");
function $7ce66ef054949ea8$export$8a2e0f615212a6a7() {
    if ($7ce66ef054949ea8$export$bdf060f8502bcfbd().runSnowfallAnimation) return true;
    else if ($7ce66ef054949ea8$export$bdf060f8502bcfbd().runSnowfallAnimation === false) return false;
    else return undefined;
}
function $7ce66ef054949ea8$export$bdf060f8502bcfbd() {
    try {
        const settingsJSON = localStorage.getItem("userSettings");
        const settings = JSON.parse(settingsJSON) || {};
        return settings;
    } catch (error) {
        (0, $2rQlw.logError)(`Error retrieving user settings: ${error}`);
        return null;
    }
}
function $7ce66ef054949ea8$export$a09ac3e43ac36a79(newSettings) {
    try {
        const existingSettingsJSON = localStorage.getItem("userSettings");
        const existingSettings = JSON.parse(existingSettingsJSON) || {};
        const mergedSettings = {
            ...existingSettings,
            ...newSettings
        };
        const mergedSettingsJSON = JSON.stringify(mergedSettings);
        localStorage.setItem("userSettings", mergedSettingsJSON);
        (0, $2rQlw.logInfo)("User settings saved successfully.");
    } catch (error) {
        (0, $2rQlw.logError)(`Error saving user settings: ${error}`);
    }
}

});

parcelRegister("3CjFT", function(module, exports) {
module.exports = $parcel$resolve("dLFrV");

});


parcelRegister("1Q7uz", function(module, exports) {

$parcel$export(module.exports, "setParams", function () { return $1570758f1b3be5bc$export$dc1827290674c112; });

var $bgAfJ = parcelRequire("bgAfJ");

var $2rQlw = parcelRequire("2rQlw");

var $6aTH5 = parcelRequire("6aTH5");
function $1570758f1b3be5bc$export$dc1827290674c112(configParams) {
    const defaultParams = (0, $bgAfJ.getDefaultParams)();
    const params = $1570758f1b3be5bc$export$28ea1ca525ed812a(defaultParams, configParams);
    (0, $2rQlw.logInfo)("Done setting snowfall-js-plugin parameters.");
    return params;
}
function $1570758f1b3be5bc$export$28ea1ca525ed812a(defaultConfig, configParams) {
    const mergedConfig = {
        ...defaultConfig
    };
    for(const key in configParams)if (configParams.hasOwnProperty(key)) {
        // Validate if the key exists in the defaultConfig
        if (!(key in defaultConfig)) {
            (0, $2rQlw.logWarn)(`Warning: '${key}' does not exist in the default configuration and will be ignored.`);
            continue;
        }
        const configValue = configParams[key];
        const defaultValue = defaultConfig[key];
        // Validate if the types match
        if (typeof configValue !== typeof defaultValue) {
            (0, $2rQlw.logWarn)(`Warning: Type mismatch for '${key}'. Using default value.`);
            continue;
        }
        // Recursive merge for nested objects
        if (configValue instanceof Object && !Array.isArray(configValue) && defaultValue instanceof Object && !Array.isArray(defaultValue)) mergedConfig[key] = $1570758f1b3be5bc$export$28ea1ca525ed812a(defaultValue, configValue);
        else // Overwrite values from configParams into mergedConfig
        mergedConfig[key] = configValue;
    }
    // Additional logic for handling reduced motion preference
    if (configParams !== null && configParams.checkReducedMotionPreference === true && configParams.hasOwnProperty("setReducedMotion") && configParams.setReducedMotion === "reduce") {
        const reduceMultiplier = (0, $6aTH5.validateReduceMultiplier)(mergedConfig, configParams);
        mergedConfig.snowfall.count = Math.round(mergedConfig.snowfall.count * reduceMultiplier);
    }
    return mergedConfig;
}

});
parcelRegister("bgAfJ", function(module, exports) {

$parcel$export(module.exports, "getDefaultParams", function () { return $833d4f61bb100d79$export$23e4d4234edf4b25; });
/**
 * Retrieves the default parameters for the application.
 *
 * @returns {object} The default parameters object.
 */ function $833d4f61bb100d79$export$23e4d4234edf4b25() {
    return $833d4f61bb100d79$var$defaultParams;
}
const $833d4f61bb100d79$var$defaultParams = {
    logLevel: "default",
    checkHardware: true,
    checkDateRange: true,
    dateRange: {
        startMonth: 12,
        endMonth: 2,
        startDay: 15,
        endDay: 15
    },
    autostartOnMobile: true,
    autostartOnDesktop: true,
    screenWidthThreshold: 768,
    checkReducedMotionPreference: true,
    setReducedMotion: "disable",
    reduceMultiplier: 0.5,
    // experimental: reduces snowfall count by 50%, use value between 0.1-0.9
    snowfall: {
        count: 33,
        minRadius: 10,
        maxRadius: 30,
        minSpeed: 3,
        maxSpeed: 6,
        text: "\u2744",
        color: "#99ccff",
        zIndex: "1000",
        canvasHeightLimit: 0
    },
    switches: {
        show: true,
        storeUserSettings: true,
        txt: "Snow",
        txtElemAttributes: [],
        injectCSS: true,
        styles: {
            /* background color of the switch when turned off */ bgClrOff: "rgba(189, 195, 199, 1)",
            /* background color of the switch when turned on */ bgClrOn: "rgba(149, 165, 166, 1)",
            /* color of the moving toggle inside switch */ toggleClr: "#ffffff",
            /* color and position of the text next to the switch */ txtClr: "rgba(33, 37, 41, 1)",
            txtPosition: "2"
        }
    }
};

});


parcelRegister("g8WoB", function(module, exports) {

$parcel$export(module.exports, "getAutoStart", function () { return $bc0ab0e5f6f85cd0$export$e61d1c3f5b3887; });

var $aIQ6J = parcelRequire("aIQ6J");

var $2rQlw = parcelRequire("2rQlw");
function $bc0ab0e5f6f85cd0$export$e61d1c3f5b3887(configParams) {
    const autostartConfig = $bc0ab0e5f6f85cd0$var$getAutostartConfig(configParams);
    const userPreference = (0, $aIQ6J.checkUserSettings)(); // true, false or undefined
    (0, $2rQlw.logInfo)(`Autostart Config Value: ${autostartConfig}`);
    (0, $2rQlw.logInfo)(`User Preference: ${userPreference}`);
    // user preferences takes precedence over autoStartConfig
    if (userPreference !== undefined) return userPreference;
    else return autostartConfig;
}
/**
 * Determines the auto-start configuration based on the provided parameters.
 *
 * @param {Object} configParams - Configuration parameters.
 * @returns {boolean} - True if the animation should auto-start, false otherwise.
 */ function $bc0ab0e5f6f85cd0$var$getAutostartConfig(configParams) {
    if (configParams.autostartOnMobile && configParams.autostartOnDesktop) return true;
    else {
        const screenWidthThreshold = configParams.screenWidthThreshold || 768;
        if (window.innerWidth >= screenWidthThreshold && configParams.autostartOnDesktop) return true;
        else if (window.innerHeight <= screenWidthThreshold && configParams.autostartOnMobile) return true;
        else return false;
    }
}

});


parcelRegister("8bUbP", function(module, exports) {

$parcel$export(module.exports, "snowfallJsPluginParams", function () { return $5f6aeff19a929ddc$export$8546e27d37a44fe5; });
const $5f6aeff19a929ddc$export$8546e27d37a44fe5 = {
    snowfall: {
        count: 54,
        canvasHeightLimit: 4
    },
    switches: {
        txt: "Sneeuw",
        txtElemAttributes: [
            {
                type: "data-attribute",
                name: "txt_id",
                value: "[702]"
            }
        ],
        styles: {
            bgClrOff: "#F9E3AE40",
            bgClrOn: "#003f8c",
            toggleClr: "#2496ed",
            txtClr: "#2496ed"
        }
    }
};

});


var $26c453cf717ab021$exports = {};
$parcel$extendImportMap({
    "dLFrV": "snowAnimationSwitchStyles.1d265b48.css"
});


parcelRequire("dkTiG");

//# sourceMappingURL=vendor.a0d65553.js.map
